var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76436 15.7639L2.10839 14.1079C1.47279 13.4775 1.51338 12.3797 2.21013 11.7982C7.72196 6.27776 16.3173 6.31749 21.7921 11.8009C22.4853 12.3791 22.5264 13.4721 21.8948 14.1049L20.2355 15.7642C19.9697 16.0352 19.6146 16.2006 19.2364 16.2294C18.1612 16.3114 16.1034 14.9979 15.5765 14.1847C15.1652 13.5497 15.3265 12.6563 15.3272 11.9399C13.1579 11.3453 10.8672 11.3476 8.69677 11.9465C8.69607 12.6629 8.85565 13.5559 8.44303 14.1917C7.9137 15.0073 5.84454 16.3311 4.76728 16.2431C4.38527 16.2119 4.02834 16.0413 3.76436 15.7639Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDown);
export default __webpack_public_path__ + "static/media/phone-down.e3809d0b0e15501846d77fcb08c8ac8c.svg";
export { ForwardRef as ReactComponent };